/**
 * Central store for context attached to New Relic error reports.
 * Updated by NewRelicErrorContextProvider; read at error-report time.
 * All values are string | number | boolean for New Relic custom attributes.
 */

export type NewRelicErrorContext = {
  urlQueryParams?: string;
  userType?: 'guest' | 'logged_in';
  userId?: string | number;
  pageTemplate?: string;
  routePath?: string;
  buildId?: string;
  vercelEnv?: string;
};

let currentContext: NewRelicErrorContext = {};

export function setErrorContext(ctx: Partial<NewRelicErrorContext>): void {
  currentContext = { ...currentContext, ...ctx };
}

export function getErrorContext(): Record<string, string | number | boolean> {
  const attrs: Record<string, string | number | boolean> = {};
  if (currentContext.urlQueryParams !== undefined) {
    attrs.urlQueryParams = currentContext.urlQueryParams;
  }
  if (currentContext.userType !== undefined) {
    attrs.userType = currentContext.userType;
  }
  if (currentContext.userId !== undefined) {
    attrs.userId =
      typeof currentContext.userId === 'number'
        ? currentContext.userId
        : String(currentContext.userId);
  }
  if (currentContext.pageTemplate !== undefined) {
    attrs.pageTemplate = currentContext.pageTemplate;
  }
  if (currentContext.routePath !== undefined) {
    attrs.routePath = currentContext.routePath;
  }
  if (currentContext.buildId !== undefined) {
    attrs.buildId = currentContext.buildId;
  }
  if (currentContext.vercelEnv !== undefined) {
    attrs.vercelEnv = currentContext.vercelEnv;
  }
  return attrs;
}
